import createAction from 'Store/utils/createAction';
import {
  ADD_TRAVEL_COMPANION,
  EDIT_TRAVEL_COMPANION,
  SELECT_TRAVEL_COMPANION,
  UNSELECT_TRAVEL_COMPANION,
} from './travel-companion.reducer';
export const addTravelCompanion = (payload: TravelCompanion) =>
  createAction(ADD_TRAVEL_COMPANION, payload);
export const editTravelCompanion = (payload: TravelCompanion) =>
  createAction(EDIT_TRAVEL_COMPANION, payload);
type SelectArgs = {
  companionId: number;
  parentIndex: number;
  position: number;
};
export const selectTravelCompanion = (payload: SelectArgs) =>
  createAction(SELECT_TRAVEL_COMPANION, payload);
export const unselectTravelCompanion = (payload: SelectArgs) =>
  createAction(UNSELECT_TRAVEL_COMPANION, payload);
